import React from 'react';
//import LandingBg from '../images/bg-landing.jpeg'
import Typed from 'react-typed';
// import resume from "../images/pergentino-galang-CV.pdf"
import bg from '../images/bg.jpg'

const Landing = () => {

    return (
        <div id="landing">

            {/* <div className="contaiter-fluid" id="landing-page" style={bgStyle}> */}
            <div className="contaiter-fluid" id="landing-page">
                <div className='d-flex justify-content-around flex-wrap'>
                    <div className="masthead">
                        <div className="container d-flex h-100 align-items-center" id="landingpage">
                            <div className="mx-auto text-center" id="landingpage" >
                                <h1 className="mx-auto my-0  text-white wow bounceInLeft" data-wow-delay="0.3s" data-wow-duration="1s"> Hello, I'm <span className="masthead1" >Pergent Galang</span></h1>
                                <h1 className="text-white mx-auto mt-2 mb-5 wow bounceInRight" data-wow-delay="0.3s" data-wow-duration="1s">I'm a <span className="type">
                                    <Typed
                                        strings={['Full Stack', 'Frontend', 'Backend']}
                                        typeSpeed={40}
                                        backSpeed={40}
                                        showCursor={false}
                                        loop={true}
                                        backDelay={1000}

                                    /></span><br /> web developer</h1>
                                    <a href="#project" className="btn-cv btn btn-danger scroll wow bounceInRight" data-wow-duration="1s" data-wow-delay="0.3s" id="cv">View my work</a>
                                {/* <a href={resume} download className="btn-cv btn btn-danger wow bounceInRight" data-wow-duration="2s" data-wow-delay="1s" id="cv">Download CV <i className="fas fa-cloud-download-alt"></i></a>
                                <a href="#project" className="btn-work btn btn-outline-danger scroll wow bounceInLeft" data-wow-duration="2s" data-wow-delay="1s" id="work"> View my work </a> */}

                            </div>
                        </div>
                    </div>
                    <div>
                        <span className="landing-circle-image mx-auto d-block mt-5 wow slideInUp" data-wow-delay="0.3s" data-wow-duration="1s">
                            <img src={bg} alt='hi'></img>
                        </span>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Landing;